import React, { useMemo } from 'react';
import PropTypes, { any } from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';

import DraggableMatch from './DraggableMatch';
import { MatchStatusTypes } from '../../../utils/nextAvailable';

import styles from './nextAvailable.scss';
import { sportTypeIds } from '../../../utils/eventConstants';

const MatchContainer = (props) => {
    const {
        eventId,
        sportTypeId,
        displayType,
        statusType,
        className,
        playersDictByMemberId,
        teamsDict,
        eventSchedule,
        onPostScoreClick,
    } = props;

    const nextAvailable = useSelector(({ nextAvailable }) => nextAvailable);

    const {
        isLoadingMatches,
    } = nextAvailable?.sidebar || {};

    const matches = useMemo(() => {
        return nextAvailable.notOnCourtMatches[statusType]?.filter((match) => match.drawMatchStatus === statusType) || [];
    }, [nextAvailable.notOnCourtMatches, statusType, displayType]);

    return (
        <>
            {isLoadingMatches && (
                <div className={styles.spinner} data-testid="next-available.matches.loading">
                    <div className={styles.iconWrapper}>
                        <i className="icon-utr-logo" />
                        <div className={styles.iconSpinner} />
                        <div className={`${styles.iconSpinner} ${styles.reverse}`} />
                    </div>
                    <div className={styles.title}>Loading</div>
                </div>
            )}
            {!isLoadingMatches && (
                <Droppable
                    droppableId="match-container"
                    isDropDisabled={statusType !== MatchStatusTypes.IN_QUEUE}
                >
                    {(provided) => (
                        <div
                            className={className}
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            data-testid="next-available.matches.list"
                        >
                            {matches.map((match, index) => {
                                return (
                                    <DraggableMatch
                                        eventId={eventId}
                                        sportTypeId={sportTypeId}
                                        key={`match-${match.id}-${index}`}
                                        match={match}
                                        index={index}
                                        className="mb8"
                                        playersDictByMemberId={playersDictByMemberId}
                                        teamsDict={teamsDict}
                                        eventSchedule={eventSchedule}
                                        onPostScoreClick={onPostScoreClick}
                                        statusType={statusType}
                                        data-testid={`next-available.match-${match.id}`}
                                    />
                                );
                            })}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            )}
        </>
    );
};

MatchContainer.propTypes = {
    className: PropTypes.string,
    matches: PropTypes.arrayOf(any),
    displayType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    statusType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    playersDictByMemberId: PropTypes.objectOf(PropTypes.any).isRequired,
    teamsDict: PropTypes.objectOf(PropTypes.any).isRequired,
    eventSchedule: PropTypes.objectOf(PropTypes.any).isRequired,
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    sportTypeId: PropTypes.number,
    onPostScoreClick: PropTypes.func.isRequired,
};

MatchContainer.defaultProps = {
    className: '',
    sportTypeId: sportTypeIds.TENNIS,
    matches: [],
};

export default MatchContainer;
